<app-header [actionLeft]="appHeaderLeftAction"></app-header>
<app-toaster></app-toaster>
<app-sub-header></app-sub-header>
<app-loading-panel class="main-loading-panel" *ngIf="(isLoading$ | async) === true"></app-loading-panel>
<div class="plan-content">
  <app-push-aside-content [showAside]="isPlanNavVisible"
                          [squeezeMain]="true" asideWidth="260px" [overlayMain]="false">
    <app-aside-content>
      <i (click)="isPlanNavVisible = false" *ngIf="isPlanNavVisible"
         auto="left-nav-close-tog" class="nav-toggle-btn close-btn eleot-icon left-menu-pane-close"></i>
      <app-plan-tree (planCoordinateClick)="onPlanCoordinateClick($event)" [planCoordinate]="planCoordinate" [planTree]="planTree"></app-plan-tree>
    </app-aside-content>
    <app-main-content #mainContent>
      <i (click)="isPlanNavVisible = true" *ngIf="!isPlanNavVisible"
         auto="left-nav-open-tog" class="nav-toggle-btn open-btn eleot-icon left-menu-pane-open"></i>
      <app-banner-msg #bannerMsgComp></app-banner-msg>
      <app-determine-current-reality *ngIf="planCoordinate.planStep === PlanStep.DETERMINE_CURRENT_REALITY"
                                     [permissions]="permissions"
                                     [strategyId]="strategyId"
                                     [planCoordinate]="planCoordinate"
                                     (itemDelete)="onResourceDelete($event)"
                                     [guideUrl]="guideUrlForStep(PlanStep.DETERMINE_CURRENT_REALITY)"
                                      >
      </app-determine-current-reality>
      <app-explore-the-future *ngIf="planCoordinate.planStep === PlanStep.EXPLORE_THE_FUTURE"
                              [permissions]="permissions"
                              [strategyId]="strategyId"
                              [planCoordinate]="planCoordinate"
                              (itemDelete)="onResourceDelete($event)"
                              [guideUrl]="guideUrlForStep(PlanStep.EXPLORE_THE_FUTURE)"
      >
      </app-explore-the-future>
      <app-synthesize-results
        *ngIf="planCoordinate.planStep === PlanStep.SYNTHESIZE_RESULTS"
        [permissions]="permissions"
        [planCoordinate]="planCoordinate"
        [purposeMissionBeliefs]="purposeMissionBeliefs"
        [priorities]="priorities"
        [strategyId]="strategyId"
        (updatePurpose)="onUpdatePurpose($event)"
        (updateMission)="onUpdateMission($event)"
        (updateBeliefs)="onUpdateBeliefs($event)"
        (priorityCreate)="onPriorityCreate($event)"
        (priorityEdit)="onPriorityEdit($event)"
        (itemDelete)="onPriorityDelete($event)"
        (itemError)="onPriorityError($event)"
        (prioritySort)="refetchPurposeMissionBeliefs($event)"
        (prioritySortFail)="reloadSynthesizeResults($event)"
        [guideUrl]="guideUrlForStep(PlanStep.SYNTHESIZE_RESULTS)"
      >
      </app-synthesize-results>
      <app-creating-objectives-critical-initiatives *ngIf="planCoordinate.planStep === PlanStep.CREATE_OBJECTIVES_AND_CRITICAL_INITIATIVES"
                                                    [permissions]="permissions"
                                                    [planCoordinate]="planCoordinate"
                                                    [strategyId]="strategyId"
                                                    (itemError)="onObjectiveOrInitiativeError($event)"
                                                    (initiativeSortFail)="reloadCreateObjectivesCriticalInitiatives($event)"
                                                    (reloadInitiatives)="reloadCreateObjectivesCriticalInitiatives($event)"
                                                    [guideUrl]="guideUrlForStep(PlanStep.CREATE_OBJECTIVES_AND_CRITICAL_INITIATIVES)"
      >
      </app-creating-objectives-critical-initiatives>
      <app-identifying-outcomes-key-measures *ngIf="planCoordinate.planStep === PlanStep.IDENTIFY_OUTCOMES_AND_KEY_MEASURES"
                                             [permissions]="permissions"
                                             [strategyId]="strategyId"
                                             [planCoordinate]="planCoordinate"
                                             [guideUrl]="guideUrlForStep(PlanStep.IDENTIFY_OUTCOMES_AND_KEY_MEASURES)">
      </app-identifying-outcomes-key-measures>
      <app-develop-strategy-map *ngIf="planCoordinate.planStep === PlanStep.DEVELOP_STRATEGY_MAP"
                                [permissions]="permissions"
                                [planCoordinate]="planCoordinate"
                                (planCoordinateChange)="onPlanCoordinateChange($event)"
                                [guideUrl]="guideUrlForStep(PlanStep.DEVELOP_STRATEGY_MAP)">
      </app-develop-strategy-map>
      <app-develop-annual-plan *ngIf="planCoordinate.planStep === PlanStep.DEVELOP_THE_ANNUAL_PLAN"
                               [permissions]="permissions"
                               [strategyId]="strategyId"
                               [planCoordinate]="planCoordinate"
                               [guideUrl]="guideUrlForStep(PlanStep.DEVELOP_THE_ANNUAL_PLAN)">
      </app-develop-annual-plan>
      <!--[priorities]="prioritiesWithInitiativesActivities"-->
      <app-design-implementation-plan *ngIf="planCoordinate.planStep === PlanStep.DESIGN_THE_IMPLEMENTATION_PLAN"
                                      [permissions]="permissions"
                                      [strategyId]="strategyId"
                                      [planCoordinate]="planCoordinate"
                                      [guideUrl]="guideUrlForStep(PlanStep.DESIGN_THE_IMPLEMENTATION_PLAN)">
      </app-design-implementation-plan>
      <!--[planHasInitiatives]="planHasInitiatives"-->
      <!--[priorities]="prioritiesWithInitiativesActivities"-->
      <app-enact-monitor-progress *ngIf="planCoordinate.planStep === PlanStep.ENACT_AND_MONITOR_PROGRESS"
                                  [permissions]="permissions"
                                  [planCoordinate]="planCoordinate"
                                  [strategyId]="strategyId"
                                  (updateInitiativeStatus)="onUpdateInitiativeStatus($event)"
                                  (trackInitiative)="onTrackInitiative($event)"
                                  [guideUrl]="guideUrlForStep(PlanStep.ENACT_AND_MONITOR_PROGRESS)">
      </app-enact-monitor-progress>
      <!--[impact]="impact"-->
      <!--(updateImpact)="onUpdateImpact($event)"-->
      <app-outcome-impact *ngIf="planCoordinate.planStep === PlanStep.DETERMINE_IMPACT_OF_CRITICAL_INITIATIVES"
                          [permissions]="permissions"
                          [planCoordinate]="planCoordinate"
                          [strategyId]="strategyId"
                          (itemDelete)="onResourceDelete($event)"
                          (planCoordinateChange)="onPlanCoordinateChange($event)"
                          [guideUrl]="guideUrlForStep(PlanStep.DETERMINE_IMPACT_OF_CRITICAL_INITIATIVES)">
      </app-outcome-impact>
      <app-judge-success *ngIf="planCoordinate.planStep === PlanStep.JUDGE_SUCCESS_OF_ANNUAL_PLAN"
                         [permissions]="permissions"
                         [planCoordinate]="planCoordinate"
                         [strategyId]="strategyId"
                         (itemDelete)="onResourceDelete($event)"
                         (planCoordinateChange)="onPlanCoordinateChange($event)"
                         [guideUrl]="guideUrlForStep(PlanStep.JUDGE_SUCCESS_OF_ANNUAL_PLAN)">

      </app-judge-success>
      <app-deliverables *ngIf="planCoordinate.planStep === PlanStep.OUTPUTS"
                        [strategyId]="strategyId"
                        [permissions]="permissions"
                        [planCoordinate]="planCoordinate"
                        (planCoordinateChange)="onPlanCoordinateChange($event)"
                        [guideUrl]="guideUrlForStep(PlanStep.OUTPUTS)">
      </app-deliverables>

      <div class="next-steps-row" *ngIf="isNextStepsVisible">
        <div class="flex-right-left">
          <ng-container *ngIf='isCompleteSwitchVisible'>
            <span class="tagline">Is your work completed?</span>
            <p-inputSwitch auto="completed-tog" styleClass="strategies-input-switch" onLabel="Yes" offLabel="No"
                          [ngModel]="isStepComplete" (onChange)="onToggleStepComplete()">
            </p-inputSwitch>
          </ng-container>
        </div>
        <div class="step-buttons">
          <button auto="prev-btn" class="btn btn-alt" (click)="onClickPreviousStep()" [hidden]="!isPreviousStepVisible()">Previous</button>
          <button auto="next-btn" class="btn btn-primary" (click)="onClickNextStep()" [hidden]="!isNextStepVisible()">Next</button>
        </div>
      </div>
    </app-main-content>
  </app-push-aside-content>
</div>

<p-dialog #confirmDialog styleClass="strategies-deliverable-prompt" [modal]="true" [closable]="false">
  <p-header>
    <span>Did you know?</span>
  </p-header>
  <div class="content-container flex-right-left">
    <img class="prompt-img" src="assets/images/deliverable-prompt-output.jpg" alt="deliverable information">
    <div class="content-left">
      <div class="instructions">
        Content completed during each phase or subphase can be accessed through the Output icon.
        <br><br>
        Select the Output icon in the left-hand navigation menu from any screen.
      </div>
      <div class="flex-right-left">
        <div>
          <div class="checkbox checkbox-branded">
            <input type="checkbox" id="show-deliverable-prompt"
                   auto="not-show-again-tog" [(ngModel)]="isPreventDeliverablePrompt"/>
            <label for="show-deliverable-prompt"></label>
          </div>
          <span class="checkbox-label">Don't show again</span>
        </div>
        <button auto="close-btn" class="btn" type="button" pButton label="Close" (click)="onConfirmDialogAccept()"></button>
      </div>
    </div>
  </div>
</p-dialog>
